// extracted by mini-css-extract-plugin
module.exports = {"CALandingPage":"CA_CALandingPage__x1vpX"};